import { render, staticRenderFns } from "./MdColor.vue?vue&type=template&id=5374c20d&"
import script from "./MdColor.vue?vue&type=script&lang=js&"
export * from "./MdColor.vue?vue&type=script&lang=js&"
import style0 from "./MdColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports